/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
var OverlayTab = function ( editor ) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setId( 'overlayTab' );

	var selected = null;
	var values;

	function build() {

		container.clear();

		if ( selected === null ) return;

		values = {};

		// Display

		var row = new UI.Row();
		row.add( new UI.Text( 'Display' ).setWidth( '90px' ) );
        container.add( row );

		//Position of origin

		var row = new UI.Row();
		row.add( new UI.Text( 'Position of origin' ).setWidth( '90px' ) );
		container.add( row );

		var [x, y, z] = selected.origin.position

		var input = new UI.Input( `(${x}, ${y}, ${z})` );
		input.onChange( function () {

			const val = this.getValue().substring(1, this.getValue().length - 1)
			const position = val.split(',').map(s => parseInt(s.trim()))
			selected.origin.position[0] = position[0]
			selected.origin.position[1] = position[1]
			selected.origin.position[2] = position[2]
			
		} );
		row.add( input );

		//Rotation of origin

		var row = new UI.Row();
		row.add(new UI.Text('Rotation of origin').setWidth('90px'));
		container.add(row);

		var [x, y, z] = selected.origin.rotation

		var input = new UI.Input(`(${x}, ${y}, ${z})`);
		input.onChange(function () {
			const val = this.getValue().substring(1, this.getValue().length - 1)
			const rotation = val.split(',').map(s => parseInt(s.trim()))
			selected.origin.rotation[0] = rotation[0]
			selected.origin.rotation[1] = rotation[1]
			selected.origin.rotation[2] = rotation[2]

		});
		row.add(input);
        
        //Overlay Text
        var row = new UI.Row();
		row.add( new UI.Text( 'Overlay Text' ).setWidth( '90px' ) );
        container.add( row );
        
		var input = new UI.Input(selected.value || '');
		input.onChange( function () {

			selected.value = this.getValue();

		} );
		row.add( input );

		// Time

		var row = new UI.Row();
		row.add(new UI.Text('Time').setWidth('45px'));
		container.add(row);

		var animationStart = new UI.Number(selected.start).setWidth('45px');
		animationStart.onChange(function () {

			selected.start = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(animationStart);

		var animationEnd = new UI.Number(selected.end).setWidth('45px');
		animationEnd.onChange(function () {

			selected.end = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(animationEnd);
	
	}

	signals.animationSelected.add( function ( animation ) {
	
		selected = animation;
		build();
	} );

	signals.animationModified.add(function (animation) {
		selected = animation;
		build();
	});


	signals.effectCompiled.add( build );

	return container;

};

export default OverlayTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/OverlayTab.js
// module id = null
// module chunks = 